import { useTrackEventAmplitude } from '../../../../core/Tracking/Amplitude/Amplitude';
import { IconSparkle } from '../../../../design-system/components/icons/Sparkle';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { Destination } from '../../../../resources/destination/domain/types/destination';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';

import style from './ABTripDesignerCard.module.css';

type Props = {
    destination: PickDomain<Destination, 'id' | 'slug'>;
    utmCampaign?: 'page-list-itinerary' | 'page-itinerary';
};

export function ABTripDesignerCard({ destination, utmCampaign = 'page-list-itinerary' }: Props) {
    const { trackEvent } = useTrackEventAmplitude();

    const tripDesignerUrl = `https://trip-designer.evaneos.fr/onboarding/destination?destinationId=${destination.id}&utm_source=evaneos&utm_medium=card&utm_campaign=${utmCampaign}`;

    const handleClick = () => {
        trackEvent((ampli, defaultProperties) => {
            ampli.pathfinderTripBuilderBannerClicked({
                ...defaultProperties,
                destination_id: destination.id,
                destination_slug: destination.slug,
            });
        });
    };

    return (
        <a
            href={tripDesignerUrl}
            className={style.card}
            onClick={handleClick}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className={style.backgroundImage} />
            <div className={style.content}>
                <Typography as="div" scale="secondary-s-bold" className={style.title}>
                    Générez un premier itinéraire qui vous ressemble
                </Typography>
                <div className={style.ctaButton}>
                    <IconSparkle className={style.ctaIcon} />
                    <span>Commencer</span>
                </div>
            </div>
        </a>
    );
}
